import * as zod from 'zod';

const FIELD_NAME = 'phone';
const PHONE_DIGITS = 13; // NOTE spaces included
const PHONE_NUMBER_PREFIX_MASK = '+7';
const PHONE_NUMBER_MASK = 'XXX XXX XX XX';

const PHONE_NUMBER_ERRORS = {
  GOOGLE_INCORRECT_USER_PROVIDER: 'GOOGLE_INCORRECT_USER_PROVIDER',
  PROFILE_PHONE_ALREADY_EXISTS: 'PROFILE_PHONE_ALREADY_EXISTS',
  PROFILE_PHONE_ALREADY_LINKED: 'PROFILE_PHONE_ALREADY_LINKED',
  USER_NOT_FOUND: 'USER_NOT_FOUND',
  PROFILE_PHONE_INVALID: 'PROFILE_PHONE_INVALID',
  PROFILE_PHONE_TOO_SHORT: 'PROFILE_PHONE_TOO_SHORT'
};

const phoneNumberSchema = zod.object({
  [FIELD_NAME]: zod
    .string()
    .min(PHONE_DIGITS, PHONE_NUMBER_ERRORS.PROFILE_PHONE_TOO_SHORT)
}).required();

export {
  FIELD_NAME,
  PHONE_DIGITS,
  PHONE_NUMBER_ERRORS,
  phoneNumberSchema,
  PHONE_NUMBER_MASK,
  PHONE_NUMBER_PREFIX_MASK
};
